export default function ($http) {
    return function (taskId) {
        return $http.put(`api/tasks/${ taskId }/complete`);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/tasks/completeTask.js